module.exports = __webpack_public_path__ + "static/img/1110.2fa31c84.png";